export default __webpack_public_path__ + "static/media/fragenUndAntworten.12d58d47.jpg";